// getters.js
export default {
  shareOffcanvas: (state) => state.shareOffcanvas,
  getUser: (state) => state.user,
  getMfaStatus: (state) => state.mfaEnabled,
  getShowMfaPrompt: (state) => state.showMfaPrompt,
  getProfilePhotoURL: (state) => state.profilePhotoURL,
  getAssessmentUserResponses: (state) =>
    state.assessmentUserResponses.map((x) => ({ ...x })),
  getAssessmentReviewUserResponses: (state) =>
    state.assessmentReviewUserResponses.map((x) => ({ ...x })),
  getAppColors: (state) => state.colors,
  getSelectedOrg: (state) => state.selectedOrg,
  getSelectedAssessment: (state) => state.selectedAssessment,
  getFilteredAssessments: (state) => state.filteredAssessments,
  getCurrentSection: (state) => state.currentSection,
  getAssessments: (state) => state.assessments,
  getOrganisations: (state) => state.organisations,
  getQuestions: (state) => state.questions,
};
